import { toast } from "react-toastify";

export function notify(message, type = "success") {
  console.log("toasting", message, type);
  toast[type](message, { position: toast.POSITION.TOP_CENTER });
}



// WEBPACK FOOTER //
// ./src/components/notification/index.js